import type { TaskResult } from "../types";

export async function gradeProject8(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Eliminar duplicados en "Ciudades capitales del mundo"
  // Original tiene 198 filas, con 2 duplicados (Greece/Athens, Tunisia/Tunis) → 196 filas
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Ciudades capitales del mundo");
    const table = ws.tables.getItem("CiudadesCapitales");
    const bodyRange = table.getDataBodyRange();
    bodyRange.load("rowCount");
    await context.sync();

    // 198 originales - 2 duplicados = 196
    const passed = bodyRange.rowCount === 196;
    results.push({ taskId: 1, passed });
  });

  // Tarea 2: Modo de cálculo manual
  await Excel.run(async (context) => {
    const app = context.workbook.application;
    app.load("calculationMode");
    await context.sync();

    const mode = String(app.calculationMode).toLowerCase();
    const passed = mode === "manual";
    results.push({ taskId: 2, passed });
  });

  // Tarea 3: INDEX+MATCH en G2 de "Ciudades capitales del mundo"
  // =INDICE(C:C,COINCIDIR(F2,B:B,0)) o variantes
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Ciudades capitales del mundo");
    const celda = ws.getRange("G2");
    celda.load("formulas");
    await context.sync();

    const formula = (celda.formulas[0][0] || "").toString().toUpperCase();
    const tieneIndex = formula.includes("INDEX") || formula.includes("INDICE");
    const tieneMatch = formula.includes("MATCH") || formula.includes("COINCIDIR");

    results.push({ taskId: 3, passed: tieneIndex && tieneMatch });
  });

  // Tarea 4: Segmentación de datos para columna País en "Top 15 Ciudades"
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Top 15 Ciudades");
    const slicers = context.workbook.slicers;
    slicers.load("items");
    await context.sync();

    let passed = false;
    for (const slicer of slicers.items) {
      slicer.load("targetConnection,worksheet");
      await context.sync();

      // Verificar que hay un slicer conectado a la tabla dinámica de esta hoja
      slicer.load("caption");
      await context.sync();

      const caption = (slicer.caption || "").toLowerCase();
      if (caption.includes("país") || caption.includes("pais") || caption.includes("country")) {
        passed = true;
        break;
      }
    }
    results.push({ taskId: 4, passed });
  });

  // Tarea 5: Verificar que Clasificación está como primer campo de fila
  // (el estudiante debe agregarlo encima de Ciudad Capital)
  await Excel.run(async (context) => {
    const ws = context.workbook.worksheets.getItem("Top 15 Ciudades");
    const pivotTables = ws.pivotTables;
    pivotTables.load("items");
    await context.sync();

    let passed = false;
    for (const pt of pivotTables.items) {
      const rowHierarchies = pt.rowHierarchies;
      rowHierarchies.load("items/name");
      await context.sync();

      // Must have at least 2 row hierarchies, with Clasificación first
      if (rowHierarchies.items.length >= 2) {
        passed = rowHierarchies.items[0].name === "Clasificación";
      }
      break;
    }
    results.push({ taskId: 5, passed });
  });

  return results;
}
